import graphql__f043df011c9c43ef0680 from "./__generated__/AnswerPreviewFile_answer.graphql.js";import { createFragmentContainer } from "react-relay";
import { graphql } from "react-relay";

import ButtonLink from "../Buttons/ButtonLink";
import { truncateCentered } from "../../helpers/StringHelper";

const AnswerPreviewFile = props => {
  if (props.answer.sources.length) {
    return props.answer.sources.map(source => {
      return (
        <ButtonLink
          key={source.url}
          href={source.url}
          className="btn btn-outline-primary text-wrap"
          target="_blank"
          label={truncateCentered(source.name, 32)}
          title={source.name}
          iconClassName="form-answer-file-icon icon-document-txt"
        />
      );
    });
  } else {
    return "-";
  }
};

export default createFragmentContainer(AnswerPreviewFile, {
  answer: graphql__f043df011c9c43ef0680
});
